<template>
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;">
    <v-flex xs6 class="inline-block px-4">
      <label>{{$t('Admin.AdminFleet.Form.Libelle')}}:</label>&nbsp;<span>{{fleet.FLE_LIBELLE}}</span><br/>      
    </v-flex>
  </v-layout>        
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import Fiche from '@/components/admin/Fiche.vue'

  @Component({
    name: 'FicheAdminFleet'
  })
  export default class FicheAdminFleet extends Vue {  
    
    get fleet() {
      return this.$store.myGetters.originalAdmAdminFleet
    }
    
  }
</script>